import type { StateCreator } from 'zustand';

import type { AuthSlice, GlobalStore } from '../schema';

export const createAuthSlice: StateCreator<
  GlobalStore,
  [['zustand/devtools', never]],
  [],
  AuthSlice
> = (set) => ({
  accessToken: '',
  setAccessToken: (token) => set({ accessToken: token }, false, 'auth/setAccessToken'),
});
